<template> 
    <div class="portfolio-item-container">
        <div v-for="(item, idx) in projets" :key="idx" :style="{ backgroundImage: 'url('+require('./../../assets/'+item.bg+'')+')'}"  class="portfolio-item">
             <div class="portfolio-container"> 
                <div class="col-content">
                    <div class="portfolio-logo">
                        <img :src="require(`./../../assets/${item.logo}`)" :alt="item.alt" />
                    </div>
                    <div class="portfolio-header">
                        <p class="light"> {{ item.header }}</p>
                    </div>
                    <div class="portfolio-sep"></div>
                    <div class="portfolio-description">
                        <p class="light">{{ item.descriptionTitle }}</p>
                        <ul>
                            <li v-for="(list, idk) in item.lists" :key="idk">{{ list }}</li>
                        </ul>
                    </div>
                    <div class="portfolio-btn" v-if="item.linkWeb">
                        <a class="btn-main" target="_blank"  :href="item.linkWeb" >Découvrir le site</a>
                    </div>
                </div>
                <div class="col-mockup">
                    <img :src="require(`./../../assets/${item.mockup}`)" alt="mockup" />
                </div>
             </div>   
        </div>
    </div>
</template>

<script>


export default {
    name: 'PortfolioItem',
    props : ['items'],
    data(){
        return {
            projets :[]
        }
    },
    mounted() {
        let portfolio = this.$store.getters.getPortfolios
        //boucle sur les items pour conserver l'ordre
        this.items.forEach(item =>  {
            portfolio.forEach(element => {
                if(item.indexOf(element.id) != -1 ) {
                    this.projets.push(element)
                }
            });
        });

    }

}
</script>

<style scoped>

    .portfolio-item-container {
        display:flex;
        flex-direction: column;
    }

    .portfolio-section {
        display:flex;
        flex-direction: column;
    }

    .portfolio-item {
        display: flex;
        height:100vh;
        width:100%;
        justify-content: center;
        align-items: center;
        border-bottom:3px solid #ffffff;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }

    .portfolio-container {
        width:1200px;
        display: flex;
        align-items: center;
    }

    .col-content {
        flex: 2 1 0;
        min-width:380px;
    }

    .col-mockup {
        flex: 5 1 0;
    }



    .portfolio-sep {
        height:3px;
        width:50%;
        background: linear-gradient(to right, #ef4337,#fbab37);
    }

    .portfolio-header, .portfolio-description, .portfolio-header p, .portfolio-description p {
        color:#ffffff;
        text-align: left;
    }

    .portfolio-description p {
        font-size:18px;
        margin-bottom: 0;
    }

    .portfolio-description ul {
        margin-bottom:40px;
        list-style: none
    }

    .portfolio-description ul li {
        margin-bottom: 5px;
        position:relative;
    }

    .portfolio-description ul li:before {
        content: '';
        height: 6px;
        width: 6px;
        border-radius: 50%;
        background: #fbab37; 
        position: absolute;
        left: -1em;
        top: 7px;
    }

    .portfolio-logo {
        margin-bottom:40px;
    }

    .portfolio-logo img {
        max-width: 100%;
    }



    @media screen and (max-width: 950px)  {
        .col-mockup {
            display: none;
        }

        .col-content {
            width:100%;
            min-width: auto;
            padding:0 20px;
        }
    }

    @media screen and (min-width: 950px) and (max-width: 1400px)  {

        .col-content {
            padding:0 20px;
        }

        .col-mockup img {
            max-width: 90%;
        }
    }

</style>